const setShareStatus = (root, message) => {
  const status = root.querySelector('[data-share-status]');
  if (status) status.textContent = message;
};

document.addEventListener('click', (event) => {
  const activeShare = event.target.closest('.tvara-product-share');

  document.querySelectorAll('.tvara-product-share[open]').forEach((share) => {
    if (share !== activeShare) share.removeAttribute('open');
  });
});

document.addEventListener('click', async (event) => {
  const nativeButton = event.target.closest('[data-share-native]');
  const copyButton = event.target.closest('[data-share-copy]');
  const button = nativeButton || copyButton;
  if (!button) return;

  const root = button.closest('.tvara-product-share');
  const url = root?.dataset.shareUrl;
  if (!root || !url) return;

  if (nativeButton && navigator.share) {
    await navigator.share({ title: root.dataset.shareTitle, url }).catch(() => {});
    return;
  }

  if (copyButton && navigator.clipboard) {
    await navigator.clipboard.writeText(url)
      .then(() => setShareStatus(root, 'Link copied'))
      .catch(() => setShareStatus(root, 'Copy failed'));
  }
});

if (navigator.share) {
  document.querySelectorAll('[data-share-native]').forEach((button) => {
    button.hidden = false;
  });
}
